import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import ant from 'ant-design-vue';
import { store } from './store';
import { setupGlobDirectives } from '/@/directives';
import { Image } from 'ant-design-vue';

Image.props.preview = false;

import 'ant-design-vue/dist/antd.less';
import '/@/assets/styles/views/app.less';

const app = createApp(App);
// Register global directive
setupGlobDirectives(app);

app.use(router).use(store).use(ant).mount('#app');

(function (doc, win, imgW) {
  var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function () {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      if (clientWidth >= imgW) {
        docEl.style.fontSize = '100px';
      } else {
        docEl.style.fontSize = 100 * (clientWidth / imgW) + 'px';
      }
    };

  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window, 750);
